import { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface ToolLayoutProps {
  children: ReactNode;
  title: string;
  description: string;
}

const tools = [
  { name: 'JSON Formatter', path: '/dev-tools/json-formatter' },
  { name: 'Base64 Encode', path: '/dev-tools/base64-encode' },
  { name: 'Base64 Decode', path: '/dev-tools/base64-decode' },
  { name: 'JWT Decoder', path: '/dev-tools/jwt-decode' },
];

export default function ToolLayout({ children, title, description }: ToolLayoutProps) {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950">
      <div className="border-b border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-900">
        <div className="container py-8">
          <h1 className="mb-2 text-3xl font-bold text-gray-900 dark:text-gray-50">{title}</h1>
          <p className="text-gray-600 dark:text-gray-400">{description}</p>
        </div>
      </div>

      <div className="container py-8">
        <div className="grid gap-8 lg:grid-cols-[250px_1fr]">
          {/* Sidebar Navigation */}
          <aside className="lg:sticky lg:top-24 lg:h-fit">
            <nav className="card space-y-1">
              <h2 className="mb-3 text-sm font-semibold text-gray-900 dark:text-gray-50">Developer Tools</h2>
              {tools.map(tool => (
                <Link
                  key={tool.path}
                  to={tool.path}
                  className={`block rounded-lg px-3 py-2 text-sm transition-colors ${
                    location.pathname === tool.path
                      ? 'bg-primary-100 font-medium text-primary-700 dark:bg-primary-950 dark:text-primary-300'
                      : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800'
                  }`}
                >
                  {tool.name}
                </Link>
              ))}
            </nav>
          </aside>

          {/* Main Content */}
          <main>{children}</main>
        </div>
      </div>
    </div>
  );
}
